// Authentication functions for all user roles
import { auth, graphqlClient } from './graphqlClient';

export const loginAdmin = async (email, password) => {
  return auth.login(email, password, 'admin');
};

export const loginEngine = async (email, password) => {
  return auth.login(email, password, 'engine');
};

export const loginReseller = async (email, password) => {
  return auth.login(email, password, 'reseller');
};

export const loginMerchant = async (email, password) => {
  return auth.login(email, password, 'merchant');
};

export const logout = () => {
  return auth.logout();
};

export const getCurrentUser = async () => {
  return auth.me();
};

export const isAuthenticated = () => {
  return auth.isAuthenticated();
};

export const getUserRole = () => {
  return auth.getUserRole();
};

export const loginStaff = async (email, password, panelType) => {
  const mutationMap = {
    ADMIN: 'staffAdminLogin',
    ENGINE: 'staffEngineLogin',
    RESELLER: 'staffResellerLogin',
    MERCHANT: 'staffMerchantLogin',
  };

  const mutationName = mutationMap[panelType];
  if (!mutationName) {
    throw new Error('Invalid panel type');
  }

  const query = `
    mutation StaffLogin($input: StaffLoginInput!) {
      ${mutationName}(input: $input) {
        accessToken
        refreshToken
        userId
        email
        name
        role
      }
    }
  `;

  const result = await graphqlClient.mutate(query, {
    input: { email, password, panelType },
  });

  if (result[mutationName]) {
    const authData = result[mutationName];
    graphqlClient.setTokens(
      authData.accessToken,
      authData.refreshToken,
      authData.role,
      {
        userId: authData.userId,
        email: authData.email,
        name: authData.name,
      }
    );
    return authData;
  }

  throw new Error('Staff login failed');
};





